import Vue from 'vue'
import axios from 'axios'
import io from 'socket.io-client'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import messageService from 'vue-update-message'
// import './registerServiceWorker'
import logger from './logger'
import {
  getToken,
  setToken,
  removeToken,
  loadModule
} from './util'
import mixinDate from './mixin/date'
import analytics from './analytics'
import './assets/scss/app.scss'
import DatePicker from 'vue2-datepicker'
import VCalendar from 'v-calendar'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'

import VuejsDialog from 'vuejs-dialog'

// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

// Tell Vue to install the plugin.
Vue.use(VuejsDialog)

Vue.config.productionTip = false

// Start time for closing splashscreen
Vue.prototype.startTime = new Date()

// Analytics
Vue.prototype.$analytics = analytics

// Mixin
Vue.mixin(mixinDate)

Vue.use(VCalendar)

// Mask
Vue.use(VueTheMask)
Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  precision: 2
})
// Message
const ConfigMsg = {
  position: 'fixed',
  width: 'auto',
  placement: 'bottom',
  successText: '#0B3B24',
  successBackground: '#CEF6CE',
  successBorder: '#0B3B24',
  errorText: '#B40404',
  errorBackground: '#faa7bc',
  errorBorder: '#B40404'
}
Vue.use(messageService, ConfigMsg)

Vue.use(DatePicker)

// Socket.IO incluído no bundle; polling evita falha no upgrade WebSocket do nginx.
Vue.prototype.$socket = io(process.env.VUE_APP_API, {
  transports: ['polling'],
  upgrade: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
  timeout: 10000
})

// Error handler
Vue.config.errorHandler = (err, vm, info) => {
  logger.error(err, vm)
}

// Warning handler
Vue.config.warnHandler = (msg, vm, trace) => {
  logger.warn(msg, vm)
}

// Default interceptor for Unauthorized 401
axios.interceptors.response.use(undefined, error => {
  if (error && error.response && error.response.status === 401) {
    removeToken()
    loadModule('main')
    return { data: null }
  }
  return Promise.reject(error)
})

// Inside function because async
const run = async () => {
  try {
    const token = getToken()
    if (token) {
      // Set token on axios header
      setToken(token)
      // Get user from backend
      const { data } = await axios.get(`${process.env.VUE_APP_API}/auth/user`)
      if (!data) return false
      // Renew token
      setToken(data.token)
      if (data.user.role === 'admin') {
        // Start admin module
        loadModule('admin', data.user)
      } else if (data.user.role === 'business' || data.user.role === 'producer') {
        // Start business module
        loadModule('business', data.user, data.business || null)
      } else if (data.user.role === 'user') {
        // Start business module
        loadModule('user', data.user)
      } else {
        // Start user module
        loadModule('main', data.user)
      }
    } else {
      // Start core module
      loadModule('main')
    }
  } catch (error) {
    logger.error(error)
    removeToken()
    // Start core module
    loadModule('main')
  }
}

document.title = 'Swiss Money'
run()
